/**
 * withContentGroups
 * HOC for wrapping the provided component with ContentGroupsProvider
 */

import React from 'react'

import ContentGroupsProvider from './content-groups-provider'

export default function withContentGroups (WrappedComponent) {
  return function ContentGroupsProviderHOC(props) {
    return (
      <ContentGroupsProvider>
        <WrappedComponent {...props} />
      </ContentGroupsProvider>
    )
  }
}
